import slideStyle from "./InfoPage.module.scss";
import kiosk1 from "../assets/kiosk1.jpg";
import kiosk2 from "../assets/kiosk2.jpg";
import kiosk3 from "../assets/kiosk3.jpg";
import kiosk4 from "../assets/kiosk4.jpg";
import kiosk5 from "../assets/kiosk5.jpg";
import ContactAppendix from "./ContactAppendix";
import ReactFastMarquee from "react-fast-marquee";
import Heading from "./Heading";
import { getMessage, MessageContext } from "@messageformat/react";
import { useContext } from "react";
import { Message } from "@messageformat/react";

const KioskAI = () => {
  const messageContext = useContext(MessageContext);

  return (
    <>
      <Heading
        subtitle={<Message id="infoPages.aiKiosk.subtitle" />}
        title={<Message id="infoPages.aiKiosk.title" />}
        hints={[
          <Message id="infoPages.aiKiosk.hints.hint1" />,
          <Message id="infoPages.aiKiosk.hints.hint2" />,
          <Message id="infoPages.aiKiosk.hints.hint3" />,
        ]}
      />

      <ReactFastMarquee
        gradientColor={[0, 0, 0]}
        autoFill={true}
        style={{ margin: "30px 0", padding: 0 }}
      >
        <img
          alt="Kiosk z AI"
          style={{ height: "250px", float: "right", margin: "0 50px" }}
          src={kiosk1}
        />
        <img
          alt="Kiosk z AI"
          style={{ height: "250px", float: "right", margin: "0 50px" }}
          src={kiosk2}
        />
        <img
          alt="Kiosk z AI"
          style={{ height: "250px", float: "right", margin: "0 50px" }}
          src={kiosk3}
        />
        <img
          alt="Kiosk z AI"
          style={{ height: "250px", float: "right", margin: "0 50px" }}
          src={kiosk4}
        />
        <img
          alt="Kiosk z AI"
          style={{ height: "250px", float: "right", margin: "0 50px" }}
          src={kiosk5}
        />
      </ReactFastMarquee>

      <div className={slideStyle.section} style={{ marginTop: "5px" }}>
        <div>
          <h2
            dangerouslySetInnerHTML={{
              __html: getMessage(
                messageContext,
                "infoPages.aiKiosk.description1"
              )(),
            }}
          />
          <p
            dangerouslySetInnerHTML={{
              __html: getMessage(
                messageContext,
                "infoPages.aiKiosk.description2"
              )(),
            }}
          />
          <p
            style={{ marginBottom: "10px" }}
            dangerouslySetInnerHTML={{
              __html: getMessage(
                messageContext,
                "infoPages.aiKiosk.description3"
              )(),
            }}
          />
          <p
            dangerouslySetInnerHTML={{
              __html: getMessage(
                messageContext,
                "infoPages.aiKiosk.description4"
              )(),
            }}
          />
        </div>

        <div className={slideStyle.embeddedImg}>
          <img alt="Kiosk z AI" src={kiosk1} />
        </div>

        <div>
          <h2
            dangerouslySetInnerHTML={{
              __html: getMessage(
                messageContext,
                "infoPages.aiKiosk.description5"
              )(),
            }}
          />
          <p
            dangerouslySetInnerHTML={{
              __html: getMessage(
                messageContext,
                "infoPages.aiKiosk.description6"
              )(),
            }}
          />
          <p
            dangerouslySetInnerHTML={{
              __html: getMessage(
                messageContext,
                "infoPages.aiKiosk.description7"
              )(),
            }}
          />
          <p
            dangerouslySetInnerHTML={{
              __html: getMessage(
                messageContext,
                "infoPages.aiKiosk.description8"
              )(),
            }}
          />
        </div>

        <div
          className={slideStyle.heading}
          style={{ marginTop: "20px", marginBottom: "20px" }}
        >
          <h1
            dangerouslySetInnerHTML={{
              __html: getMessage(
                messageContext,
                "infoPages.aiKiosk.aiSection.title"
              )(),
            }}
          />
          <img
            alt="Kiosk z AI"
            style={{ width: "400px", float: "left", margin: "0 20px 20px 0" }}
            src={kiosk2}
          />
        </div>

        <div
          dangerouslySetInnerHTML={{
            __html: getMessage(
              messageContext,
              "infoPages.aiKiosk.aiSection.description"
            )(),
          }}
        />

        <div
          className={slideStyle.heading}
          style={{ marginTop: "20px", marginBottom: "20px" }}
        >
          <h1
            dangerouslySetInnerHTML={{
              __html: getMessage(
                messageContext,
                "infoPages.aiKiosk.languageBarrierSection.title"
              )(),
            }}
          />
        </div>
        <div
          dangerouslySetInnerHTML={{
            __html: getMessage(
              messageContext,
              "infoPages.aiKiosk.languageBarrierSection.description"
            )(),
          }}
        />

        <div style={{ textAlign: "center" }}>
          <h2
            dangerouslySetInnerHTML={{
              __html: getMessage(
                messageContext,
                "infoPages.aiKiosk.safeposSection.title"
              )(),
            }}
          />
          <p
            dangerouslySetInnerHTML={{
              __html: getMessage(
                messageContext,
                "infoPages.aiKiosk.safeposSection.description"
              )(),
            }}
          />
        </div>
        <ContactAppendix />
      </div>
    </>
  );
};

export default KioskAI;
